import { createAction } from '@reduxjs/toolkit';

// Never replace a material/topic with an editor or live endpoint response:
// enrolment completion, publication and the curriculum relationships stay local.
export const updateActivityDefinition = createAction<{
  id: string;
  class_topic_id: string;
  file_name: string;
  description: string;
  activity_config?: Model.ClassTopicContents['activity_config'];
}>('activity/updateDefinition');

export const updateActivitySchedule = createAction<{
  id: string;
  start_at: string;
  end_at?: string | null;
}>('activity/updateSchedule');
